import Vue from "vue";

export const authService = {
  login,
  recoverPassword,
  refresh,
  me
};

function login(email, password) {
  return Vue.axios.post("v1/auth/jwt_token", { email, password });
}

function recoverPassword(email) {
  return Vue.axios.post("v1/password/forgot", { email });
}

function refresh(token) {
  const headers = { "Refresh-Token": token };
  return Vue.axios.post("v1/auth/jwt_token/refresh", {}, { headers });
}

function me() {
  return Vue.axios.get("v1/me");
}
